export default "__VITE_ASSET__CL6T_yhg__"